import { Zap, ZapOff, Cpu } from 'lucide-react'
import { useAIStore } from '../store/aiStore'
import { isAIConfigured } from '../lib/anthropic'

export default function AIControls({ collapsed }) {
  const { isEnabled, model, setEnabled, setModel, currentDailyCount } = useAIStore()
  const configured = isAIConfigured()
  const active     = isEnabled && configured
  const count      = currentDailyCount()

  if (collapsed) {
    return (
      <div className="flex flex-col items-center gap-1.5 py-3"
        style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        <button
          onClick={() => configured && setEnabled(!isEnabled)}
          title={!configured ? 'API key missing' : isEnabled ? 'Disable AI' : 'Enable AI'}
          className="w-7 h-7 rounded-lg flex items-center justify-center transition-all"
          style={{ background: active ? 'rgba(37,99,235,0.2)' : 'rgba(255,255,255,0.04)' }}
        >
          {active
            ? <Zap    style={{ width: 13, height: 13, color: '#60a5fa' }} />
            : <ZapOff style={{ width: 13, height: 13, color: '#475569' }} />
          }
        </button>
        {model === 'OPUS' && active && (
          <Cpu style={{ width: 11, height: 11, color: '#c084fc' }} />
        )}
      </div>
    )
  }

  return (
    <div className="px-3 py-3" style={{ borderTop: '1px solid rgba(255,255,255,0.06)' }}>
      {/* Toggle row */}
      <div className="flex items-center justify-between mb-2.5">
        <div className="flex items-center gap-1.5">
          {active
            ? <Zap    style={{ width: 12, height: 12, color: '#60a5fa' }} />
            : <ZapOff style={{ width: 12, height: 12, color: '#475569' }} />
          }
          <span className="font-sans text-xs font-medium"
            style={{ color: active ? '#94a3b8' : '#475569' }}>
            {!configured ? 'Key missing' : active ? 'AI enabled' : 'AI disabled'}
          </span>
        </div>
        <button
          onClick={() => configured && setEnabled(!isEnabled)}
          disabled={!configured}
          className="relative w-8 h-[18px] rounded-full transition-colors duration-200 disabled:opacity-30 disabled:cursor-not-allowed"
          style={{ background: active ? '#2563eb' : '#334155' }}
          title={!configured ? 'AI is unavailable — check the backend configuration' : undefined}
        >
          <span
            className="absolute top-[2px] w-[14px] h-[14px] rounded-full bg-white transition-all duration-200"
            style={{ left: active ? '18px' : '2px' }}
          />
        </button>
      </div>

      {/* Model selector */}
      <div className="flex gap-1 mb-2">
        {['SONNET', 'OPUS'].map(m => (
          <button
            key={m}
            onClick={() => setModel(m)}
            className="flex-1 py-1 rounded font-mono font-medium transition-all"
            style={{
              fontSize: 10,
              background: model === m
                ? m === 'OPUS' ? 'rgba(192,132,252,0.15)' : 'rgba(37,99,235,0.15)'
                : 'rgba(255,255,255,0.04)',
              border: `1px solid ${model === m
                ? m === 'OPUS' ? 'rgba(192,132,252,0.4)' : 'rgba(37,99,235,0.4)'
                : 'rgba(255,255,255,0.08)'}`,
              color: model === m
                ? m === 'OPUS' ? '#c084fc' : '#60a5fa'
                : '#475569',
            }}
          >
            {m === 'SONNET' ? 'Standard' : 'Deep Academic'}
          </button>
        ))}
      </div>

      {/* Status line */}
      <div className="flex items-center justify-between">
        {model === 'OPUS' && active ? (
          <span className="flex items-center gap-1 px-1.5 py-0.5 rounded font-mono font-semibold"
            style={{ fontSize: 9, background: 'rgba(192,132,252,0.12)', color: '#c084fc', border: '1px solid rgba(192,132,252,0.25)', letterSpacing: '0.08em' }}>
            <Cpu style={{ width: 9, height: 9 }} />
            OPUS ACTIVE
          </span>
        ) : <span />}
        <span className="font-mono" style={{ fontSize: 10, color: '#334155' }}>
          {count} call{count !== 1 ? 's' : ''} today
        </span>
      </div>
    </div>
  )
}
